"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumTypeSwitchWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PremiumTypeSwitchWidget = /** @class */ (function (_super) {
    __extends(PremiumTypeSwitchWidget, _super);
    function PremiumTypeSwitchWidget(props) {
        return _super.call(this, props) || this;
    }
    PremiumTypeSwitchWidget.prototype.render = function () {
        var _this = this;
        var annualSelected = this.props.interaction.factors.premiumType === "annual";
        return ((0, jsx_runtime_1.jsx)("div", { className: "row premium-type-switch", children: (0, jsx_runtime_1.jsx)("div", { className: "col-12", children: (0, jsx_runtime_1.jsxs)("div", { className: "float-right tier-premium-type", children: [(0, jsx_runtime_1.jsx)("div", { className: annualSelected ? "annual selected" : "annual", onClick: function (e) { return _this.switchPremiumType(); }, children: (0, jsx_runtime_1.jsx)("span", { children: "Annual" }) }), (0, jsx_runtime_1.jsx)("div", { className: "p-0 background-color-grey", children: (0, jsx_runtime_1.jsx)("div", { className: annualSelected ? "tier-premium-type-input annual" : "tier-premium-type-input monthly", onClick: function (e) { return _this.switchPremiumType(); }, children: (0, jsx_runtime_1.jsx)("span", {}) }) }), (0, jsx_runtime_1.jsx)("div", { className: annualSelected ? "monthly" : "monthly selected", onClick: function (e) { return _this.switchPremiumType(); }, children: (0, jsx_runtime_1.jsx)("span", { children: "Monthly" }) })] }) }) }));
    };
    PremiumTypeSwitchWidget.prototype.switchPremiumType = function () {
        var newPremiumType = this.props.interaction.factors.premiumType === "annual" ? "monthly" : "annual";
        this.props.executePremiumChange(newPremiumType);
    };
    return PremiumTypeSwitchWidget;
}(React.Component));
exports.PremiumTypeSwitchWidget = PremiumTypeSwitchWidget;
//# sourceMappingURL=PremiumTypeSwitchWidget.js.map